module.exports = __webpack_public_path__ + "static/media/hamburger.db1df2b3.svg";